import styles from "@styles/home/heroBanner.module.scss";

const generateNewBannerHtml = () => `
  <section class="${styles.betterthatBanner}">
    <div class="${styles.bannerContent}">
      <div class="${styles.contentWrapper}">
        <div class="${styles.textContent}">
          <h3><strong>About Drummoyne Rowing Club</strong></h3>
          <p> Drummoyne Rowing Club is a community-based club located on Henley Marine Drive, Drummoyne.  </p>
          <p>We aim to provide access for all standards of rowers to enjoy the sport and realise their aspirations.  Over the years, the club has seen many of its athletes reach the pinnacle of the sport at Olympic Games and World Championships.</p>
<!--           <a class="${styles.customBatn}" href="/products">Shop Now</a>-->
        </div>

        <div class="${styles.imageContent}">
          <img src="/assets/home/hero-cover.jpg" alt="Betterthat Connect illustration" />
        </div>
      </div>
    </div>
  </section>
        <div class="heading-section lulaBg text-center" >
        Shop Now
        </div>
`;
export const replaceBanner = (data) => {
  if (!data || !data.raw_data) {
    return data;
  }

  try {
    const rawData = JSON.parse(data.raw_data);
    if (Array.isArray(rawData.blocks)) {
      const newBannerHtml = generateNewBannerHtml();

      rawData.blocks = rawData.blocks.map((block) => {
        if (
          block.includes('class="shop-now-block"') &&
          block.includes('data-block-type="home_new"') &&
          block.includes('data-id="1"')
        ) {
          return newBannerHtml;
        }

        if (block.includes('class="proud_title"')) {
          return block.replace(/Better That/g, "Drummoyne Rowing Club");
        }
        return block;
      });

      return {
        ...data,
        raw_data: JSON.stringify(rawData),
      };
    }
  } catch (error) {
    console.error("Error parsing or modifying raw_data:", error);
  }

  return data;
};
